import styled, { css } from 'styled-components';

export const ComboItemContent = styled.div`
    display: flex;
    flex-direction: column;
`;

export const ItemDateTextContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 0.3125rem;
`;

export const ItemDateText = styled.span`
    display: flex;
    align-items: center;
    gap: 0.3125rem;
    cursor: pointer;
`;

export const Modal = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
`;

export const ModalContent = styled.div`
    background: white;
    border-radius: 0.5rem;
    padding: 1.25rem;
    max-width: 31.25rem;
    width: 90%;
    box-shadow: 0 0.125rem 0.625rem rgba(0, 0, 0, 0.1);
`;

export const ModalActions = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 0.625rem;
`;

export const ComboItemContainer = styled.div`
    padding: 0.75rem;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;

    border-radius: 0.75rem;
    background: var(--Neutral-0, #fff);
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);

    .header {
        position: relative;
        display: flex;
        align-items: center;
        gap: 0.75rem;

        img {
            height: 4rem;
            width: 4rem;
            object-fit: cover;
            border-radius: 0.375rem;
        }

        .title-row {
            display: flex;
            gap: 0.25rem;
            align-items: center;

            span.price {
                color: #999;
                font-size: 1rem;
                font-weight: 600;
                line-height: 1rem;
            }
        }

        .actions {
            display: flex;
            gap: 0.75rem;
            margin-left: auto;
            align-items: center;

            svg {
                width: 1.25rem;
                height: 1.25rem;
                color: #adadad;
            }

            .arrow-button svg {
                width: 1.5rem;
                height: 1.5rem;
                color: #27272a;
            }
        }
    }

    @media (max-width: 800px) {
        & {
            flex-direction: column;
        }

        .header {
            flex-wrap: wrap;
            img {
                min-width: 100%;
                height: 6rem;
            }
        }

        .arrow-button {
            position: absolute;
            top: -0.25rem;
            right: -0.25rem;

            svg {
                z-index: 1;
            }

            &::before {
                content: '';
                position: absolute;
                width: 100%;
                height: 100%;
                border-radius: 0.375rem;
                background: #fff;
                box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.25);
            }
        }
    }
`;

export const CartSubItemContainer = styled.div<{
    shouldBlockEditing?: boolean;
    shouldBlockItemChanges?: boolean;
    isMissingSelection?: boolean;
}>`
    display: flex;

    &.normal-type {
        box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
        padding: 0.75rem;
        border-radius: 0.75rem;
        background: var(--Neutral-0, #fff);

        ${p =>
            p.isMissingSelection
                ? css`
                      border: 1px solid #ffc107;
                  `
                : null}
    }

    .title-row {
        display: flex;
        flex-direction: column;
        gap: 0.25rem;

        h3 {
            width: 200px;
            font-size: 0.875rem;
        }

        p.price {
            color: var(--Silver-500, #999);
            font-weight: 600;
            line-height: 1rem;
            font-size: 0.875rem;
        }
    }

    > div {
        flex-grow: 1;
    }

    .column-1 {
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 0.75rem;

        .date-row {
            position: relative;
            display: flex;
            align-items: center;
            gap: 0.5rem;
            max-width: fit-content;
            cursor: pointer;

            p {
                display: flex;
                align-items: center;
                gap: 0.25rem;
                color: #71717a;

                font-size: 0.75rem;
                font-weight: 500;
            }

            .edit-icon {
                color: #27272a;
                opacity: 0;
            }

            &:before {
                content: '';
                position: absolute;
                bottom: 0;
                width: 100%;
                height: 2px;
                background-color: #27272a;
                opacity: 0;
            }

            &.undecided {
                pointer-events: none;
            }

            ${p =>
                p.shouldBlockItemChanges
                    ? 'cursor: not-allowed'
                    : css`
                          &:hover *,
                          &:hover:before {
                              color: #27272a;
                              opacity: 1;
                              cursor: pointer;
                          }
                      `}
        }
    }

    .input-row {
        display: flex;
        gap: 0.75rem;
        padding-bottom: 0.75rem;
        align-items: flex-end;
        justify-content: flex-end;

        .field-div {
            display: flex;
            flex-direction: column;
            align-items: start;
            justify-content: center;
            gap: 0.25rem;
            flex-grow: 1;

            input {
                width: 100%;
            }

            div:has(+ label) {
                width: 1rem;
                height: 1rem;
            }

            label {
                color: var(--Neutral-800, #27272a);
                font-family: 'Inter', sans-serif;
                font-size: 0.75rem;
                font-style: normal;
                font-weight: 400;
                line-height: 1rem;
            }

            .error-span {
                height: 1rem;
                color: var(--Red-400, #e11d48);
                font-size: 0.75rem;
                font-weight: 500;
                line-height: 1rem;
            }
        }

        input {
            padding: 0.75rem 1rem;
            border-radius: 0.75rem;
            outline: 1px solid var(--Neutral-300, #d4d4d8);
            border: none;
            background: var(--Neutral-0, #fff);
            box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
            flex-grow: 1;
            font-size: .9rem;
            line-height: 1.25rem;

            &::placeholder {
                color: #71717a;
                opacity: 1;
            }

            ${p =>
                p.shouldBlockEditing
                    ? null
                    : css`
                          &:focus {
                              outline: 2px solid var(--Neutral-300, #d4d4d8);
                          }
                      `}

            &.hidden-input {
                visibility: hidden;
                opacity: 0;
                pointer-events: none;
                display: none;
            }

            &.input-invalid {
                &::placeholder {
                    color: #e11d48;
                    opacity: 1;
                }
                outline: 2px solid var(--Neutral-300, #e11d48);
            }
        }

        &.fill {
            width: 100%;
        }

        .dependents-dropdown {
            border-width: 0px;
            padding: 0.75rem 1rem;
            border-radius: 0.75rem;
            flex-grow: 1;
            outline: 1px solid var(--Neutral-300, #d4d4d8);
            box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
            &.open {
                outline: 2px solid var(--Neutral-300, #d4d4d8);
            }

            font-family: 'Hero New';
            font-size: .9rem;
            line-height: 1.25rem;
            font-style: normal;
            font-weight: 400;


            &.readonly {
                pointer-events: none;
                cursor: not-allowed;
                user-select: none;

                div {
                    opacity: 0;
                }
            }
        }
    }

    .actions {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0.4rem;

        svg {
            width: 1.25rem;
            height: 1.25rem;
            color: #adadad;
        }
    }

    @media (max-width: 800px) {
        & {
            position: relative;
            flex-direction: column;
            gap: 0.75rem;
        }

        .input-row {
            flex-wrap: wrap;

            input {
                flex-grow: 1;
            }
        }

        &.normal-type .actions {
            position: absolute;
            right: 1rem;
            top: 1rem;
        }

        .date-row * {
            color: #52525b !important;
            opacity: 1 !important;
            cursor: pointer;
        }
    }
`;

export const CardPromoItemContainer = styled.div`
    display: flex;
    padding: 0.75rem;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    align-self: stretch;

    border-radius: 0.75rem;
    background: var(--Neutral-0, #fff);

    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);

    .image-wrapper {
        border-radius: 0.375rem;
        background: linear-gradient(234deg, #fe650d 34.43%, #adff0a 100%);
        width: 5.375rem;
        height: 5.375rem;
        flex-shrink: 0;
        border-radius: 0.375rem;

        img {
            height: 100%;
            width: 100%;
            object-fit: cover;
        }

        p.conffeti {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
            font-size: 2.25rem;
        }
    }

    button {
        padding: 0.75rem;
    }

    button svg {
        width: 1.25rem;
        height: 1.25rem;
    }

    .text {
        display: flex;
        flex-direction: column;
        gap: 0.75rem;
        p {
            color: var(--black, #1b1b1b);
            font-size: 0.875rem;
            font-weight: 400;
        }
    }

    @media (max-width: 800px) {
        & {
            flex-direction: column;
            gap: 0.75rem;
        }

        .image-wrapper {
            width: 100%;
        }

        .text {
            gap: 0.25rem;
        }
    }
`;
